var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 13.3332L15.4223 11.8776C15.1446 11.7388 14.8384 11.6665 14.5279 11.6665H12.4951C11.9647 11.6665 11.456 11.8772 11.0809 12.2523L8.91916 14.4141C8.54409 14.7891 8.33337 15.2978 8.33337 15.8283L8.33337 25.5961C8.33337 26.2648 8.66758 26.8893 9.22397 27.2602L17.0908 32.5048C17.8278 32.9961 18.8002 32.9442 19.4806 32.3771L28.3334 24.9998",
    stroke: "#B78727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3874 20.5807C22.784 19.7727 21.6734 19.5404 20.7967 20.0386L16.3248 22.5802C15.5422 23.025 14.5589 22.8921 13.9224 22.2556L13.2152 21.5484C12.3836 20.7168 12.4456 19.3507 13.3491 18.5978L21.1104 12.1301C21.4698 11.8305 21.9229 11.6665 22.3907 11.6665H24.5278C24.8383 11.6665 25.1445 11.7388 25.4222 11.8776L30.5611 14.4471C31.2386 14.7858 31.6666 15.4784 31.6666 16.2359L31.6666 25.6461C31.6666 27.5702 29.2155 28.3845 28.0642 26.8429L23.3874 20.5807Z",
    stroke: "#B78727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 28.3335V13.3335",
    stroke: "#B78727",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 28.3335V13.3335",
    stroke: "#B78727",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 28.3335V13.3335",
    stroke: "#B78727",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.bec2e95ac0f77d48eb36a8a6144b82c0.svg";
export { ForwardRef as ReactComponent };